import { IRoutine, ShowDetailsRight } from '../../_Common/Const/Delsystem';
import { rutinInfos } from '../../_Common/Const/RutinInfo';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';
import { useFakturaDelOnStartWarningHook } from './FakturaDel/Utils/useFakturaDelOnStartWarningHook';
import FakturaattestWrapper from './FakturaDel/Components/FakturaattestWrapper';
import { useLeverantorFakturaOnStartWarningHook } from './LeverantorFaktura/Utils/useLeverantorFakturaOnStartWarningHook';
import { useFakturaattestBusinessCollectionMenuItems } from './FakturaDel/Utils/useFakturaattestBusinessCollectionMenuItems';
import FakturaDelQuery from '../ObjektVyer/FakturaDel/Queries/FakturaDelQuery.gql';
import LeverantorQuery from '../ObjektVyer/Leverantor/LeverantorQuery.gql';
import { evictAllOfTypes } from '../../../../Utils/apolloUtils';
import LeverantorAttestWrapper from './LeverantorAttest/Components/LeverantorAttestWrapper';
const LRRutiner: { [rtnKey: string]: IRoutine } = {
  rtnLeverantorer: {
    component: getStandardRutin(rutinInfos.rtnLeverantorer, 'LRLeverantor'),
    config: {
      LRLeverantorfaktura: {
        objectLinksEnabled: true,
        defaultColumns: [
          { attributeDef: 'FAKTURA_NR', header: true },
          { attributeDef: 'FORFALLO_DATUM' },
          { attributeDef: 'Fakturabelopp2' },
          { attributeDef: 'Detaljstatus' },
        ],
      },
      LRLeverantor: {
        refetchButtonQueries: [LeverantorQuery],
      },
    },
  },
  rtnFakturabunt: {
    component: getStandardRutin(rutinInfos.rtnFakturabunt, 'LRFakturabunt'),
  },
  rtnFakturabevakning: {
    component: getStandardRutin(rutinInfos.rtnFakturabevakning, 'LRFakturaDel'),
  },
  rtnBetalRedov: {
    component: getStandardRutin(rutinInfos.rtnBetalRedov, 'LRBetalredovisning'),
  },
  rtnAttestanter: {
    component: getStandardRutin(rutinInfos.rtnAttestanter, 'LRAttestant'),
    detaljVy: 'Attestant',
  },
  rtnWebLeverantorsfakturor: {
    component: getStandardRutin(
      rutinInfos.rtnWebLeverantorsfakturor,
      'LRLeverantorfaktura'
    ),
    config: {
      LRLeverantorfaktura: {
        defaultSort: [
          {
            attributeName: 'FAKTURA_NR',
            order: 'asc',
          },
        ],
        defaultColumns: [
          { attributeDef: 'FAKTURA_NR', header: true },
          { attributeDef: 'Leverantor' },
          { attributeDef: 'FORFALLO_DATUM' },
          { attributeDef: 'Fakturabelopp2' },
          { attributeDef: 'Detaljstatus' },
        ],
      },
    },
    filterAttributes: [
      { attribute: 'FAKTURA_NR', label: 'Fakturanr' },
      { attribute: 'Fakturabelopp2', label: 'Belopp' },
      { attribute: 'Leverantor', label: 'Leverantör' },
    ],
    onStartWarningHook: useLeverantorFakturaOnStartWarningHook,
  },
  rtnWebFakturaAttest: {
    component: getStandardRutin(
      rutinInfos.rtnWebFakturaAttest,
      'LRFakturaDel',
      undefined,
      useFakturaattestBusinessCollectionMenuItems,
      FakturaattestWrapper
    ),
    detaljVy: 'FakturaAttest',
    directEditMode: true,
    filterAttributes: [
      { attribute: 'Faktura.Leverantor.LeverantorNrNamn', label: 'Leverantör' },
      { attribute: 'Faktura.Fakturabelopp2', label: 'Fakturabelopp' },
    ],
    initialUrval: 'MZFnOThfHZoddajTHxJYhYoLuYKnARtR', //'Mina fakturor för attest',
    onStartWarningHook: useFakturaDelOnStartWarningHook,
    optInDataRefreshDesktop: false,
    optInDataRefreshMobile: false,
    showDetailsRightSize: '600px',
    urvalCacheInvalidation: evictAllOfTypes(['TEDLRFakturaDel']),
    config: {
      LRFakturaDel: {
        attributes: {
          'Faktura.Fakturabelopp2': {
            optionalLabel: true,
          },
          AttestMinaStatus: {
            optionalLabel: true,
          },
        },
        refetchButtonQueries: [FakturaDelQuery],
      },
    },
    defaultVisningsTypShowDetailsRight: 'tabell',
  },

  rtnVisaLeverantorsAttester: {
    component: getStandardRutin(
      rutinInfos.rtnVisaLeverantorsAttester,
      'LRLeverantorAttest',
      undefined,
      undefined,
      LeverantorAttestWrapper
    ),
    defaultShowDetailsRight: ShowDetailsRight.DefaultTrue,
    defaultVisningsTyp: 'tabell',
    defaultVisningsTypShowDetailsRight: 'tabell',
    detaljVy: 'LeverantorAttest',
    directEditMode: true,
    initialUrval: 'RACMdszYkArZZBLLifssLuYKnARtROdE',
    showDetailsRightSize: 6,
    unusedRoutineMenuButtons: ['add'],
    urvalCacheInvalidation: evictAllOfTypes(['TEDLRLeverantorAttest']),
  },
};

export default LRRutiner;
